import { Component, OnInit } from '@angular/core';
import { PracticeTestService } from './practice-test.service';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { Subscription, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { ParentChildrenService } from 'src/app/services/parent-children.service';
import { error } from 'pdf-lib';
import { childInfo } from 'src/app/constants/constants';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-practice-test',
  templateUrl: './practice-test.component.html',
  styleUrls: ['./practice-test.component.scss'],
})
export class PracticeTestComponent implements OnInit {
  tests: any[] = [];
  courses: any[] = [];
  selectedTest: string | undefined;
  filteredTests: any[] = [];
  textFilteredTests: any[] = [];
  loading: boolean = true;
  selectedChildSubscription: Subscription = new Subscription();
  testFilter: string = '';
  // selectedChild: childInfo = {
  //   zipcode: '',
  //   country: '',
  //   skype: '',
  //   haveAcademicCoaching: false,
  //   address: '',
  //   gender: 0,
  //   mobile: '',
  //   last_name: '',
  //   student_id: 0,
  //   first_name: '',
  //   haveTestPrep: false,
  //   email: '',
  // };
  selectedChild: number = 0;
  children: any[] = [];
  role = localStorage.getItem('roleId');
  showLoader: boolean = false;
  showRetake: boolean = false;
  retakeTestDetails: any = null;
  notifier: NotifierService;
  uniqueCourses: Record<string, any[]> = {};
  roleId: number = Number(localStorage.getItem('roleId'));

  constructor(
    private practiceTestService: PracticeTestService,
    private parentChildrenService: ParentChildrenService,
    private globalApiService: GlobalApiService,
    private router: Router,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
    this.parentChildrenService.getChildren().subscribe((children: any) => {
      this.children = children;
    });
  }

  ngOnInit(): void {
    this.role = localStorage.getItem('roleId');
    if (this.role !== '4') {
      this.fetchStudentData();
    } else {
      this.parentChildrenService
        .getSelectedChildren()
        .subscribe((childIndex: string) => {
          this.selectedChild = parseInt(childIndex);
          this.fetchStudentData();
        });
    }
  }

  // getSelectedChildFromParentChildService() {
  //   this.selectedChild = this.parentChildrenService.getSelectedChild();
  // }

  fetchStudentData() {
    this.loading = true;
    // this.getSelectedChildFromParentChildService();
    forkJoin(
      this.globalApiService.getStudentCourses(
        this.role === '4' ? this.children[this.selectedChild].student_id : 0,
        this.role === '4'
      ),
      this.practiceTestService.getAllStudentTests(
        this.role === '4' ? this.children[this.selectedChild].student_id : 0,
        this.role === '4'
      )
    ).subscribe(
      (response: any[]) => {
        console.log(response);
        // let courses = JSON.parse(response[0].data) || [];
        // console.log(courses);
        // this.courses = courses;
        this.courses = [];
        const uniqueCourses: Record<string, any[]> = {};
        const tests = response[1] || [];
        tests.forEach((test: any) => {
          test.isDPSAT = test.testCode.includes('DPSAT-');
          test.isDPSAT9 = test.testCode.includes('DPSAT9-');
          if (test.status === 3) {
            let total = 0;
            if (test.section_score.length > 0) {
              for (let section in test.section_score) {
                console.log(section);
                total += test.section_score[section].score;
              }
              test.section_score['Total'] = { score: total };
            }
          }
        });
        tests.sort((first: any, next: any) => {
          const firstCompleteBy: any = moment(first.completeBy).format(
            'YYYYMMDD'
          );
          const nextCompleteBy: any = moment(next.completeBy).format(
            'YYYYMMDD'
          );
          return nextCompleteBy - firstCompleteBy;
        });
        this.tests = tests;
        this.tests.forEach((test) => {
          if (uniqueCourses[test.testTypeName]) {
            uniqueCourses[test.testTypeName].push(test);
          } else {
            this.courses.push(test.testTypeName);
            uniqueCourses[test.testTypeName] = [test];
          }
        });
        this.uniqueCourses = uniqueCourses;
        console.log(this.courses, uniqueCourses, this.uniqueCourses);
        if (this.courses.length > 0) {
          const previousTest = this.selectedTest;
          this.selectedTest = '';
          this.filterTests(previousTest || this.courses[0]);
        }
        this.loading = false;
        console.log(this.tests);
      },
      (err: Error) => {
        console.log(err);
        this.loading = false;
      }
    );
  }

  filterTests(testName: string) {
    if (this.selectedTest !== testName) {
      console.log('filter working');
      this.selectedTest = testName;
      let count = 0;

      this.filteredTests = this.uniqueCourses[this.selectedTest].filter(
        (test: any) => {
          count++;
          return test.testTypeName === testName;
        }
      );
      console.log(count);
      this.filterTestsByName();
    }
  }

  filterTestsByName() {
    this.textFilteredTests = this.filteredTests.filter((test: any) => {
      return test.testCode
        .toLowerCase()
        .includes(this.testFilter.toLowerCase());
    });
  }

  // getStudentCourses() {
  //   this.globalApiService
  //     .getStudentCourses(
  //       this.selectedChild.student_id,
  //       localStorage['roleId'] == 4 ? true : false
  //     )
  //     .subscribe();
  // }

  // getAllStudentTests() {
  //   this.practiceTestService
  //     .getAllStudentTests(
  //       this.selectedChild.student_id,
  //       localStorage['roleId'] == 4 ? true : false
  //     )
  //     .subscribe((response: any) => {
  //       console.log(response);
  //     });
  // }

  sortFn() {
    return 0;
  }

  goToTest(status: number, testId: number, testName: string) {
    if (status === 3) {
      this.router.navigateByUrl(`/report/${testId}`);
    } else {
      const newWindow = window.open(
        `${environment.location}/#/student-test/${testId}`,
        '_blank',
        `popup,width=${screen.availWidth},height=${screen.availHeight}`
      );
      if (newWindow) {
        let timer = setInterval(() => {
          if (newWindow.closed) {
            this.ngOnInit();
            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.router.navigateByUrl(`/online-test/${testId}`);
      }
    }
  }

  retakeTest(): void {
    if (!this.showLoader) {
      this.showLoader = true;
      this.globalApiService
        .reTakeTest({
          test_id: this.retakeTestDetails?.testId,
          is_pause_allowed: this.retakeTestDetails?.isPauseAllowed,
        })
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.notifier.notify('success', 'Request successful');
            this.showLoader = false;
            this.showRetake = false;
            this.retakeTestDetails = null;
            this.fetchStudentData();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          },
          error: (error: any) => {
            console.log(error);
            this.showLoader = false;
            this.notifier.notify('error', 'Unable to process!');
          },
        });
    }
  }
}
